import './ModeSwitcher.scss';
import { FC } from 'react';
import { Mode } from '../../enums';
import { FormattedMessage } from 'react-intl';
import messages from '../../locales/messages';

interface Props {
  mode: Mode;
  onChange: (mode: Mode) => void;
}

export const ModeSwitcher: FC<Props> = ({ mode, onChange }) => {
  const cn = 'mode-switcher__btn';
  return (
    <>
      <div className={`${cn}-wrapper-first`}>
        <button
          onClick={() => onChange(Mode.Cost)}
          className={`${cn} ${mode === Mode.Cost ? `${cn}--active` : ''}`}
        >
          <FormattedMessage {...messages.filter1} />
        </button>
      </div>
      <div>
        <button
          onClick={() => onChange(Mode.Frequency)}
          className={`${cn} ${mode === Mode.Frequency ? `${cn}--active` : ''}`}
        >
          <FormattedMessage {...messages.filter2} />
        </button>
      </div>
    </>
  );
};
